<template>
  <v-col cols="12">
    <div :class="$vuetify.breakpoint.mobile ? '' : 'text-center'">
      <hooper :settings="carouselAutosSettings" style="height:100%">
        <slide v-for="(car, index) in vehiculosClases" :key="index">
          <MicroCard
            :car="car"
          />
        </slide>
        <hooper-navigation slot="hooper-addons"></hooper-navigation>
      </hooper>
    </div>
  </v-col>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation,Pagination as HooperPagination } from 'hooper'
import { mapState, mapActions } from "vuex"
import 'hooper/dist/hooper.css'
import MicroCard from './MicroCard.vue'

export default {
  components: {
    MicroCard,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data: () => ({
    carouselAutosSettings: {
      autoPlay: true,
      infiniteScroll: true,
      wheelControl: false,
      playSpeed: "3000" ,
      centerMode: false,
      transition: "500",
      breakpoints: {
        1904: {
          itemsToShow: 6
        },
      	1264: {
      		itemsToShow: 4
        },
        960:{
          itemsToShow: 2
        },
      	600: {
      	  itemsToShow: 2
      	},
      	0: {
      		itemsToShow: 1,
          autoPlay:false,
      	}
      }
    },
  }),
  created() {
    this.getAutos()
  },
  computed:{
    ...mapState(['autos','modelos', 'vehiculosClases'])
  },
  methods: {
    ...mapActions(['getAutos'])
  }
}
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Carter+One&family=Londrina+Sketch&display=swap');

.rada-title {
    font-family: 'Carter One', sans-serif;
    color: white;
    font-weight: 300;
} */

.card-content {
  flex-direction: column;
  justify-content: start;
}

.image-contain img {
  object-fit: cover;
  width: 250px;
  height: 150px;
  margin-bottom: 0;
}

.no-margin {
  margin-top: 0;
  padding-top: 0;
}

</style>